module.exports = __webpack_public_path__ + "img/ios-clear-history.0daa554.webp";